import { inject, Injectable, signal } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { Api } from '../../core/constants/api.constants';
import { Collections } from '../../core/constants/collection.constants';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { QueueAlertArrayInterface, QueueAlertInterface } from '../interfaces/queue-alert.interface';
import { QueueAlert, QueueAlertArray } from '../models/queue-alert.model';
import { TargetPeopleArray } from '../../target-people/models/target-people.model';




@Injectable({
  providedIn: 'root',
})
export class QueueAlertsService {
  private apiService = inject(ApiService);

  private path = Api.url.queue_alerts;
  public title = signal<string>('Alertas de Cola');
  public resource = Collections.QUEUEALERT?.value.toLowerCase() as string;

  public queueAlerts = signal<QueueAlertArray>([]);

  constructor() {}

  private getPath(path?: string): string {
    if (path) {
      return this.getPath() + '/' + path;
    }
    return this.path.base;
  }

  get(
    id?: string,
    params?: HttpParams,
  ): Observable<QueueAlertInterface | QueueAlertArrayInterface> {
    if (!id) {
      return this.apiService.get<QueueAlertArrayInterface>(this.getPath(), {
        params: params,
      });
    } else {
      return this.apiService.get<QueueAlertInterface>(this.getPath(id), {
        params: params,
      });
    }
  }

  form(
    data: Partial<QueueAlert>,
    id?: string,
  ): Observable<QueueAlertInterface> {
    if (id) {
      return this.apiService.patch<QueueAlertInterface>(this.getPath(id), data);
    } else {
      return this.apiService.post<QueueAlertInterface>(this.getPath(), data);
    }
  }

  updateTargetPeople(id: string, targetPeopleArray: TargetPeopleArray) {
    console.log(`queueAlertsID: ${id}`);
    console.log('updateTargetPeople: ', targetPeopleArray);
    const path = `${this.getPath()}/${id}`
    console.log('path: ', path);
    return this.apiService.patch<QueueAlertInterface>(path, { target_people: targetPeopleArray })
  }
}
